export default __webpack_public_path__ + "static/media/DSC_0639.282ff407.JPG";